// extracted by mini-css-extract-plugin
export var base = "_2k-0";
export var updateBanner = "_2k-1";